import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import {
  CALLPAGE_VALID_ISO_CODES,
  GLOBAL_PHONES,
  IsoCode,
  VALID_ISO_CODES,
} from 'modules/onboarding/lib/globalPhones'
import { CHAT_VALID_ISO_CODES } from 'modules/onboarding/lib/hubspot/chat'
import { MEETING_VALID_ISO_CODES } from 'modules/onboarding/lib/hubspot/meetings'
import { isNoTouchSegment } from 'modules/onboarding/lib/noTouchSegment'

const ONBOARDING_SEGMENT = 20

const isIsoCountryCode = (isoCountryCode: string): isoCountryCode is IsoCode =>
  Object.keys(VALID_ISO_CODES).includes(isoCountryCode)

const useHubspotVariables = () => {
  const {
    company: { legalEntities, subscription, numberEmployees },
  } = useCurrentSession()
  const isoCountryCode = legalEntities.find(({ main }) => main)?.country ?? 'es'
  const signupSeats = numberEmployees
  const realSeats = subscription.currentCycleQuantity ?? 0
  const seats = Math.max(signupSeats, realSeats)
  const isOnboardingSegment = seats <= ONBOARDING_SEGMENT
  const isNoTouch = isNoTouchSegment(isoCountryCode, seats)
  const isChatAvailable = CHAT_VALID_ISO_CODES.includes(isoCountryCode) && !isNoTouch
  const isMeetingAvailable = MEETING_VALID_ISO_CODES.includes(isoCountryCode) && !isNoTouch
  const isCallAvailable = Object.keys(GLOBAL_PHONES).includes(isoCountryCode) && !isNoTouch
  const isCallPageAvailable =
    Object.keys(CALLPAGE_VALID_ISO_CODES).includes(isoCountryCode) && !isNoTouch
  const contactPhone = isIsoCountryCode(isoCountryCode) ? GLOBAL_PHONES[isoCountryCode] : null
  const shouldShowPopover =
    isMeetingAvailable || isChatAvailable || isCallAvailable || isCallPageAvailable

  return {
    isCallAvailable,
    isCallPageAvailable,
    isChatAvailable,
    isMeetingAvailable,
    contactPhone,
    shouldShowPopover,
    isNoTouchSegment,
    isOnboardingSegment,
  }
}

export default useHubspotVariables
